// ga.ts
import ReactGA from 'react-ga4';
import TagManager from 'react-gtm-module';

import { TrackingId } from "../data/constant";

interface JourneyEventParams {
    [key: string]: string | number | boolean | undefined;
}

export const initGA = (userId?: string) => {
    const trackingId = process.env.REACT_APP_GA_TRACKING_ID || TrackingId;
    const secondaryTrackingId = process.env.REACT_APP_GA_GOOGLE_PIXEL_ID;
    const trackingIds = [trackingId, secondaryTrackingId].filter(Boolean);

    ReactGA.initialize(
        trackingIds.map((id) => ({
            trackingId: id,
            gaOptions: {
                user_id: userId,
            },
        })) as any,
        // {
        //     testMode: false,
        //     gaOptions: {
        //         debug_mode: true,
        //     },
        //     gtagOptions: {
        //         debug_mode: true,
        //         send_page_view: false,
        //     },
        // }
    );

    if (trackingIds[0]?.startsWith("GTM-")) {
        TagManager.initialize({
            gtmId: trackingId,
            dataLayer: {
                user_id: userId,
            },
        });
    }

    if (userId) {
        ReactGA.set({ user_id: userId, custom_user_id: userId });
    } else {
        ReactGA.set({ user_id: "", custom_user_id: "" });
        console.log("initGA", "no userId");
    }
};

export const trackEvent = (action: string, userId: string, params?: any) => {
    ReactGA.event(action, {
        ...params,
        user_id: userId,
    });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        // event: action,
        user_id: userId,
        ...params,
    });
};

export const trackGooglePixelEvent = (send_to: string) => {
    const pixelConversionId = process.env.REACT_APP_GA_GOOGLE_PIXEL_ID || "";
    const fullConversionId = pixelConversionId ? `${pixelConversionId}/${send_to}` : send_to;

    if (typeof window !== "undefined") {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "conversion",
            send_to: fullConversionId,
        });
    }

    if (typeof window !== "undefined" && typeof window.gtag === "function") {
        window.gtag("event", "conversion", {
            send_to: fullConversionId,
        });
    } else {
        ReactGA.event("conversion", {
            send_to: fullConversionId,
        });
    }
};

export const trackCustomerJourneyEvent = (
    eventName: string,
    userId: string,
    trackingId: string,
    params: any
) => {
    // ReactGA.set({ user_id: userId });

    // GA4: params first, then user_id + tracking_id so they are never overwritten
    ReactGA.event(eventName, {
        ...params,
        user_id: userId,
        trackingId: trackingId,
    });

    // GTM dataLayer: params first, then user_id + tracking_id so tid always goes
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: eventName,
        ...params,
        user_id: userId,
        trackingId: trackingId,
    });
};

export const trackCustomerJourneyEventAndWait = (
    eventName: string,
    userId: string,
    trackingId: string,
    params: any,
    waitMs = 300 // bump up from 250
) => {
    return new Promise<void>((resolve) => {
        let settled = false;
        const done = () => {
            if (settled) return;
            settled = true;
            resolve();
        };

        try {
            // ✅ Sirf ek jagah push karo — either ReactGA OR dataLayer, dono nahi
            // ReactGA.event internally dataLayer ko push karta hai already
            ReactGA.event(eventName, {
                ...params,
                user_id: userId,
                trackingId: trackingId,
                transport_type: "beacon",
                // ❌ event_callback hata do — GA4 mein kaam nahi karta
            });

            // ✅ Agar GTM-specific data chahiye toh alag custom event naam use karo
            // taaki duplicate fire na ho
            // window.dataLayer.push({ event: `gtm_${eventName}`, ... });
            
        } catch (_error) {
            done();
            return;
        }

        // GA4 mein callback reliable nahi — setTimeout hi primary mechanism hai
        setTimeout(done, waitMs);
    });
};
